import { createShoppingCard, fetchShoppingCardByVisitorRelID } from "../reduxLib/shoppingcardLib";
import store from "../store";
import { fetchVisitorByUUID } from "../reduxLib/visitorLib";

function productCardIni() {
    const initialCard = {
        items: [],
        OrderCreation: false,
        orderIdRel: null,
        Total: 0,
        NumProd: 0,
        UserIdRel: null,
        VisitorIdRel: null
    };


    const exp = Number(localStorage.getItem("productCard_exp"));
    const productCard = localStorage.getItem("productCard");

    if (!productCard || !exp || Date.now() > exp) {
        localStorage.setItem("productCard", JSON.stringify([]));


        ensureBackendCard(initialCard);

        return [];
    }

    try {
        const parsed = JSON.parse(productCard);
        return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
        console.error("Invalid productCard JSON:", err);

        localStorage.setItem("productCard", JSON.stringify([]));
        localStorage.setItem("productCard_exp", String(Date.now() + 12 * 60 * 60 * 1000));

        return [];
    }
}
const CARD_EXPIRATION_MS = 12 * 60 * 60 * 1000;

function setProductCardExpirationFromCard(card) {
    if (!card?.createdAt) {
        console.warn("Card has no createdAt. Expiration was not set.");
        return;
    }

    const createdAtMs = new Date(card.createdAt).getTime();

    if (Number.isNaN(createdAtMs)) {
        console.warn("Invalid card createdAt:", card.createdAt);
        return;
    }

    localStorage.setItem(
        "productCard_exp",
        String(createdAtMs + CARD_EXPIRATION_MS)
    );
}

function ensureBackendCard(initialCard) {
    const vid = localStorage.getItem("vid");

    if (!vid) {
        console.warn("No visitor UUID found in localStorage.");
        return;
    }

    store
        .dispatch(fetchVisitorByUUID(vid))
        .unwrap()
        .then(visitor => {
            if (!visitor?.visitorID) {
                throw new Error("Visitor not found.");
            }

            return store
                .dispatch(fetchShoppingCardByVisitorRelID(visitor.visitorID))
                .unwrap()
                .then(existingCard => {
                    if (existingCard?.shoppingCardId) {
                        return existingCard;
                    }

                    const cardToCreate = {
                        ...initialCard,
                        VisitorIdRel: visitor.visitorID
                    };

                    return store.dispatch(createShoppingCard(cardToCreate)).unwrap();
                })
                .catch(err => {
                    console.warn(
                        "Problematic creation.",
                        err
                    );
                });
        })
        .then(card => {
            console.log("Backend card ready:", card);
            setProductCardExpirationFromCard(card);
        })
        .catch(err => {
            console.error("ensureBackendCard error:", err);
        });
}



export default productCardIni;